import React from "react";
import { Bar, Bubble, Doughnut, Line, Pie, PolarArea, Radar, Scatter } from "react-chartjs-2";
import zoom from 'chartjs-plugin-zoom'
import { getBoundingClientRect } from "../../utils/functions";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, registerables } from "chart.js";
import { TreemapController, TreemapElement } from 'chartjs-chart-treemap';
import { useRef, useEffect } from "react";
import { imageAddress } from "../../utils/useful";


ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale);
ChartJS.register(...registerables);
ChartJS.register(TreemapController, TreemapElement);

function Treemap(props) {
    const canvas = useRef(null);
    useEffect(() => {
        const chart = new ChartJS(canvas.current, {
            type: "treemap",
            data: props.data,
            options: props.options
        });
        return () => chart.destroy();
    }, [canvas, props]);
    return (
        <div>
            <canvas ref={canvas} />
        </div>
    );
}



class GaugeChart extends React.Component {
    state = {
        show: true,
        // data: [],
        data: {
            // labels: ["Jan", "Fed", "Mar", "Apr", "May", 'Jun', "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],

            datasets: [
                {
                    label: 'Sales',
                    data: [10, 10, 10],
                    fill: false,
                    // backgroundColor: ['rgb(152, 115, 255)','rgb(255, 183, 196)'],
                    backgroundColor: [
                        'rgba(231, 76, 60, 1)',
                        'rgba(255, 164, 46, 1)',
                        'rgba(46, 204, 113, 1)'
                    ],
                    borderColor: [
                        'rgba(255, 255, 255 ,1)',
                        'rgba(255, 255, 255 ,1)',
                        'rgba(255, 255, 255 ,1)'
                    ],
                    borderWidth: 5,
                    // borderColor: '#fff',
                    // borderWidth:1,

                    lineTension: 0
                    // yAxisID: 'y-axis-1',
                },
                // {
                //     label: 'Income',
                //     data: [6, 5, 5, 6, 5, 6, 7, 7, 5, 6, 5, 8],
                //     fill: false,
                //     backgroundColor: 'rgb(255, 183, 196)',
                //     borderColor: 'rgb(255, 183, 196)',
                //     lineTension: 0,
                //     type: 'line',

                //     // yAxisID: 'y-axis-1',
                // },

                // {
                //     label: 'test',
                //     data: [3, 5, 0.5, 3, 5, 0.5],
                //     fill: false,
                //     backgroundColor: 'rgb(36, 77, 225,0.2)',
                //     borderColor: 'rgba(36, 77, 225, 1)',
                //     // yAxisID: 'y-axis-1',
                // },

            ]
        },


        chartOptions: {

            indexAxis: 'y',
            responsive: true,

            rotation: -90,
            circumference: 180,
            cutoutPercentage: 95,
            cutout: 140,
            grace:40,

            legend: {
                display: false
            },


            plugins: {
                legend: {
                    position: 'bottom',
                    display: false
                },

                tooltip: {
                    enabled: false
                },

                // tooltip:{
                //     backgroundColor:'#ffffffee',
                //     titleColor:'#000',
                //     bodyColor:'#000000'

                // }
                // title: {
                //     display: true,
                //     text: 'Chart.js Horizontal Bar Chart'
                // }
            },

            elements: {
                point: {
                    radius: 4
                }
            },
            scales: {

                x: {
                    grid: {
                        color: "rgba(0, 0, 0, 0)",
                        display: false,
                        drawOnChartArea: false,
                        drawBorder: false, 
                    },

                    beginAtZero: true,

                    ticks: {
                        beginAtZero: true,
                        fontColor: '#afafaf',
                        fontSize: 12,
                    },

                },



                y: {
                    type: 'linear',
                    position: 'left',
                    id: 'y-axis-1',
                    beginAtZero: true,
                    display: false,

                    ticks: {
                        beginAtZero: true,
                        fontColor: '#afafaf',
                        fontSize: 12,
                    },

                    grid: {
                        color: '#00000010',
                        drawBorder: false, 

                    },

                },
                // {
                //     type: 'linear',
                //     display: true,
                //     position: 'right',
                //     id: 'y-axis-2',
                //     gridLines: {
                //         drawOnArea: false,
                //     },
                // },
                // {
                //     // type: 'linear',
                //     display: true,
                //     position: 'right',
                //     id: 'y-axis-3',
                //     gridLines: {
                //         drawOnArea: false,
                //     },
                // },

            },
        }


        // timeChartOptions: {
        //     bezierCurve: false,

        //     // elements: {
        //     //     line: {
        //     //         tension: 0
        //     //     }
        //     // },
        //     // pan: {
        //     //     enabled: false,
        //     //     mode: 'xy',
        //     //     modifierKey: 'shift',
        //     //     speed: 1
        //     //     // ...
        //     // },

        //     // drag:{
        //     //     enabled: true,
        //     // },

        //     zoom: {
        //         enabled: true,
        //         // drag:true,
        //         mode: 'xy',
        //         overScaleMode: 'y',
        //         modifierKey: 'shift',

        //         wheel: {
        //             enabled: false,
        //             modifierKey: 'shift',

        //         },


        //         drag: {
        //             enabled: true,
        //             modifierKey: 'shift',

        //         },

        //         pinch: {
        //             enabled: true,
        //             modifierKey: 'shift',

        //         },


        //     },




        //     scales: {
        //         // xAxes: [

        //         //     {
        //         //         gridLines: {
        //         //             color: 'transparent',
        //         //             display: false


        //         //         },
        //         //         ticks: {
        //         //             beginAtZero: true,
        //         //             fontColor: '#afafaf',
        //         //             fontSize: 12,
        //         //         },

        //         //     },
        //         // ],
        //         // yAxes: [
        //         //     {
        //         //         gridLines: {
        //         //             color: "#eeeeeeFF"

        //         //         },
        //         //         ticks: {
        //         //             beginAtZero: true,
        //         //             fontColor: '#afafaf',
        //         //             fontSize: 12,
        //         //         }
        //         //     },
        //         // ],


        //     }
        // },



    }

    // data = {
    //     labels: [],
    //     datasets: [
    //         {
    //             // label: 'Temperature',
    //             data: [],
    //             fill: false,
    //             backgroundColor: 'rgb(255, 99, 132)',
    //             borderColor: 'rgba(255, 99, 132, 0.2)',
    //             yAxisID: 'y-axis-1',
    //         },
    //         // {
    //         //     label: 'Humidity',
    //         //     data: [1, 2, 4, 1, 2, 3],
    //         //     fill: false,
    //         //     backgroundColor: 'rgb(54, 162, 235)',
    //         //     borderColor: 'rgba(54, 162, 235, 0.2)',
    //         //     yAxisID: 'y-axis-2',
    //         // },
    //         // {
    //         //     label: 'Other',
    //         //     data: [4, 7, 1, 5, 5, 1],
    //         //     fill: false,
    //         //     backgroundColor: '#90aaee',
    //         //     borderColor: '#90aaee20',
    //         //     yAxisID: 'y-axis-3',
    //         // },
    //     ],
    // }



    colors = [
        { backgroundColor: 'rgb(255, 99, 132)', borderColor: 'rgba(255, 99, 132, 0.2)' },
        { backgroundColor: 'rgb(54, 162, 235)', borderColor: 'rgba(54, 162, 235, 0.2)' },
        { backgroundColor: '#90aaee', borderColor: '#90aaee20' }
    ]



    componentDidMount() {
        window.addEventListener('resize', this.getSize)
        this.getSize()
        // Chart.register(zoom)
        // Bar.register(zoom)

    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.getSize)
    }

    getSize = () => {
        if (this.chartContainer) {
            let bound = getBoundingClientRect(this.chartContainer)

            this.setState({ show: false, height: bound.height, width: bound.width }, () => {
                this.setState({ show: true })
            })
        }
    }


    render() {
        return (
            <div className={'h-100'}>

                <div className="w-100 h-100">


                    {/* <div style={{ border: '1px solid #ebeaf2', background: '#f9f9fb', borderRadius: 15 }}>
                        <div style={{ borderBottom: '1px solid #ebeaf2' }} className="d-flex justify-content-between p-3">
                            <div>
                                <p>Income and Expense</p>
                            </div>
                            <div>
                                <p>This Fiscal Year</p>
                            </div>
                        </div>
                        <div className="p-3">

                            <Bar
                                data={this.state.data}
                                options={this.state.timeChartOptions}
                                ref={el => this.chart = el}
                                height={this.state.width > 700 ? 130 : 200}
                            />
                        </div>
                        <div style={{ borderTop: '1px solid #ebeaf2', margin: '0 5%' }} />
                        <div style={{}} className="d-flex justify-content-between p-2">
                            <div className="w-100 flexcc flex-column">
                                <div>
                                    <div className="d-flex align-items-center">
                                        <div className="mrd-2" style={{ backgroundColor: 'rgb(237, 196, 86)', width: 25, height: '9px', }} />
                                        <p>Income</p>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <div className="mrd-2" style={{ backgroundColor: 'rgb(169, 212, 125)', width: 25, height: '9px', }} />
                                        <p>Expense</p>
                                    </div>
                                </div>
                            </div>

                            <div style={{ borderRight: '1px solid #ebeaf2' }} />

                            <button className="w-100">
                                <p>Current</p>
                                <p>$0.00</p>
                            </button>

                            <button className="w-100">
                                <p>Overdue</p>
                                <p>$2,600.000</p>
                            </button>

                        </div>
                    </div> */}

                    {/* <div style={{ border: '1px solid #ebeaf2', background: '#f9f9fb', borderRadius: 15 }}>
                        <div style={{}} className="d-flex justify-content-between p-3">
                            <div>
                                <p>Cash Flow</p>
                            </div>
                            <div>
                                <p>This Fiscal Year</p>
                            </div>
                        </div>
                        <div className="row m-0" style={{ background: '#fff', borderBottomLeftRadius: 15, borderBottomRightRadius: 15 }}>

                            {this.state.show && (

                                <div ref={el => this.chartContainer = el} style={{}} className="col-10 p-3">

                                    <Line
                                        data={this.state.data}
                                        options={this.state.timeChartOptions}
                                        ref={el => this.chart = el}
                                        // height={this.state.width > 700 ? 130 : 300}
                                        height={this.state.width > 500 ? '30%' : '100%'}
                                        width={'100%'}
                                        plugins={[zoom]}

                                    />
                                </div>
                            )}

                            <div style={{ borderLeft: '1px solid #ebeaf2', margin: '5% 0' }} className="col-2 p-2">
                                <div className="w-100 flexcc flex-column" >
                                    <div>
                                        <div className="" style={{ padding: '10px 0' }}>
                                            <p style={{ color: '#777', textAlign: 'end', paddingBottom: 5 }}>Cash as on 2022/04/01</p>
                                            <p style={{ textAlign: 'end', fontSize: 14 }}>$0.00</p>
                                        </div>
                                        <div className="" style={{ padding: '10px 0' }}>
                                            <p style={{ color: '#549d06', textAlign: 'end', paddingBottom: 5 }}>Incoming</p>
                                            <div className="d-flex justify-content-end">

                                                <p style={{ fontSize: 14, color: '#252525' }}>$3,000.00</p>
                                                &nbsp;<p>+</p>
                                            </div>
                                        </div>
                                        <div className="" style={{ padding: '10px 0' }}>
                                            <p style={{ color: '#e54643', textAlign: 'end', paddingBottom: 5 }}>Outgoing</p>
                                            <div className="d-flex justify-content-end">

                                                <p style={{ fontSize: 14, color: '#252525' }}>$0.00</p>
                                                &nbsp;<p>-</p>
                                            </div>
                                        </div>
                                        <div className="" style={{ padding: '10px 0' }}>
                                            <p style={{ color: '#2485e8', textAlign: 'end', paddingBottom: 5 }}>Cash as on 2023/03/31</p>
                                            <div className="d-flex justify-content-end">

                                                <p style={{ fontSize: 14, color: '#252525' }}>$3,000.00</p>
                                                &nbsp;<p>=</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* <div style={{ borderRight: '1px solid #ebeaf2' }} />

                                <button className="w-100">
                                    <p>Current</p>
                                    <p>$0.00</p>
                                </button>

                                <button className="w-100">
                                    <p>Overdue</p>
                                    <p>$2,600.000</p>
                                </button> *

                            </div>
                        </div>
                    </div> */}
                    <div className="dashboard-widgets h-100">

                        <div className=' pt-3 d-flex position-sticky pb-2 px-3' style={{ justifyContent: 'space-between' }}>

                            <div className="">
                                <p className='text-bold text-semibig '>Sales</p>

                                <div className="flexc">
                                    <div className="mrd-2 flexcc">
                                        <img className="br-20" src={imageAddress('', 'profile')} style={{ height: 20, width: 20, objectFit: 'cover' }} />
                                    </div>
                                    <div className="flex-1 flexc">
                                        <p className='text-smaller '>Applet Name</p>
                                    </div>
                                </div>
                            </div>

                            <div className="mb-2 d-flex">

                                <div className="mrd-3 " >
                                    <div className="br-4 px-3 py-2 d-flex flex-column" style={{ backgroundColor: '#f4f4f4', alignItems: 'flex-end' }}>
                                        <div className=" mb-1 ">
                                            <p style={{ fontSize: 25, fontWeight: '600' }}>$1.500</p>
                                        </div>
                                        <div>
                                            <p style={{ fontSize: 12, color: '#777', fontWeight: '600' }}>Last Week</p>
                                        </div>
                                    </div>
                                </div>


                                <div className="d-flex flex-column" style={{ alignItems: 'flex-end' }}>
                                    <div className="br-4 px-3 py-2 d-flex flex-column" style={{ backgroundColor: '#f4f4f4', alignItems: 'flex-end' }}>

                                        <div className=" mb-1 ">
                                            <p style={{ fontSize: 25, fontWeight: '600' }}>$6,953</p>
                                        </div>
                                        <div>
                                            <p style={{ fontSize: 12, color: '#777', fontWeight: '600' }}>Last Month</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="px-3 pb-4" style={{}}>
                            {/* <div style={{ background: '#fff', padding: '0 6px 2% 6px' }}>

                                <p style={{}}>${this.props.praise}&nbsp;Urpaid Last 365 days</p>
                            </div> */}

                            {this.props.chartType == 'line' && (

                                <Line
                                    data={this.state.data}
                                    height={this.props.height}
                                    options={this.state.chartOptions}
                                    ref={el => this.chart = el}
                                />

                            )}

                            {this.props.chartType == 'pie' && (

                                <Pie
                                    data={this.state.data}
                                    height={this.props.height}
                                    options={this.state.chartOptions}
                                    ref={el => this.chart = el}
                                />

                            )}

                            {this.props.chartType == 'doughnut' && (

                                <Doughnut
                                    data={this.state.data}
                                    height={this.props.height}
                                    options={this.state.chartOptions}
                                    ref={el => this.chart = el}
                                />

                            )}

                            {this.props.chartType == 'scatter' && (

                                <Scatter
                                    data={this.state.data}
                                    height={this.props.height}
                                    options={this.state.chartOptions}
                                    ref={el => this.chart = el}
                                />

                            )}

                            {this.props.chartType == 'bar' && (

                                <Bar
                                    data={this.state.data}
                                    height={this.props.height}
                                    options={this.state.chartOptions}
                                    ref={el => this.chart = el}
                                />

                            )}

                            {/* {this.props.chartType == 'horizontalBar' && (

                                <HorizontalBar
                                    data={this.state.data}
                                    height={this.props.height}
                                    // options={this.state.chartOptions}
                                    ref={el => this.chart = el}
                                />

                            )} */}

                            {this.props.chartType == 'radar' && (

                                <Radar
                                    data={this.state.data}
                                    height={this.props.height}
                                    options={this.state.chartOptions}
                                    ref={el => this.chart = el}
                                />

                            )}

                            {this.props.chartType == 'polar' && (

                                <PolarArea
                                    data={this.state.data}
                                    height={this.props.height}
                                    options={this.state.chartOptions}
                                    ref={el => this.chart = el}
                                />

                            )}

                            {this.props.chartType == 'bubble' && (

                                <Bubble
                                    data={this.state.data}
                                    height={this.props.height}
                                    options={this.state.chartOptions}
                                    ref={el => this.chart = el}
                                />

                            )}


                            {this.props.chartType == 'treemap' && (

                                <Treemap
                                    data={this.state.data}
                                    height={this.props.height}
                                    options={this.state.chartOptions}
                                    ref={el => this.chart = el}
                                />

                            )}

                        </div>

                    </div>
                    {/*s<button className="text-smaller" style={{ color: '#007aff' }} onClick={() => this.changeZoomDirection()}>Reset Zoom</button> */}


                </div>
            </div>
        )
    }
}

export default GaugeChart;

